import { successToast, errorToast } from '../../helpers/Notification';
import { dispatchHandler } from "./../helpers/dispatchHandler";
import axios from "axios";
import {
  AVAILABLE_ROOM,
  CREATE_DRAFT,
  CREATE_MEETING,
  CREATE_MINUTES,
  DRAFT_DETAILS,
  ERRORS,
  GET_ALL_INVITED_IN,
  GET_ALL_MEETINGS,
  GET_MEETING,
  MEETING_LIST_ALL,
  MEETING_LIST_ALL_ERROR,
  MINUTES_DETAILS,
  MINUTES_TEMPLATE,
  RESOURCER_LIST_ALL,
  RESOURCER_LIST_ALL_ERROR,
  UPDATE_MEETING,
} from "./type";
// import { axios } from "../helpers/axios";
import { saveAs } from "file-saver";
import secureLocalStorage from "react-secure-storage";


const header = {
  headers: { "access-token": secureLocalStorage.getItem("token") },
};

/**
 * =========================== createDraft ======================
 * @param {*} info 
 * @param {*} directUrl 
 * @returns 
 */
export const createDraft =
  (info, directUrl) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const URL = `/api/meeting/draft/`;
        const response = await axios.post(URL, info, header);

        if (response.data) {
          dispatchHandler({
            type: CREATE_DRAFT,
            data: response.data.message,
            dispatch,
          });
          dispatchHandler({
            type: DRAFT_DETAILS,
            data: response?.data?.draft,
            dispatch,
          });
          successToast(response?.data?.message);

        }
        if (response.status === 200 && directUrl) {
          window.location.replace(directUrl);
        }
      } catch (error) {
        errorToast(error?.response?.data?.message);
        dispatchHandler({ type: ERRORS, data: null, dispatch });
      }
    };

/**
 * =========================== createMeeting =====================
 * @param info
 * @returns success message
 */
export const createMeeting =
  (info) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const formData = new FormData();
        // formData.append("name", info.name);
        // if (info.roomId) {
        //   formData.append("roomId", info.roomId);
        // }
        // formData.append("venue", info.venue);
        // formData.append("end", info.end);
        // formData.append("start", info.start);
        // formData.append("agenda", info.agenda);
        // formData.append("duration", info.duration);
        // formData.append("reminder", info.reminder);
        formData.append("body", JSON.stringify(info));
        // formData.append("participantsList", info.files);
        // formData.append("projectId", info.projectId)
        const URL = `/api/meeting`;
        const response = await axios.post(URL, formData, header);
        if (response.data) {
          dispatchHandler({
            type: CREATE_MEETING,
            data: response.data.message,
            dispatch,
          });
          successToast(response?.data?.message);
        }
        if (response.status === 200) {
          window.location.replace("/admin/meeting");
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ||
          error?.response?.data?.error.toString() || "Server Error");
        dispatchHandler({
          type: ERRORS,
          data: "Server Error",
          dispatch,
        });
      }
    };

/**
 * ======================== createRoom ==============================
 * @param {*} roomName 
 * @returns 
 */
export const createRoom =
  (roomName) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const URL = `/api/meeting/create/room`;
        const response = await axios.post(URL, { roomName }, header);
        if (response.data) {
          return response.data;
        }
        return null;
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
        return null;
      }
    };
/**
 * =========================== getAllMeetings =========================
 * @param {*} status 
 * @returns 
 */
export const getAllMeetings =
  (status) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });

        const URL = `/api/meeting/?status=${status}`;
        const { data } = await axios.get(URL, header);
        if (data) {
          dispatchHandler({
            type: GET_ALL_MEETINGS,
            data: data.meeting,
            dispatch,
          });
        }
      } catch (error) {
        // errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };
/**
 * ============================== getAllInvitedIn =====================
 * @param {*} status 
 * @returns 
 */
export const getAllInvitedIn =
  (status) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const URL = `/api/meeting/invited-in/datatable/?status=${status}`;
        const { data } = await axios.get(URL, header);
        if (data) {
          dispatchHandler({
            type: GET_ALL_INVITED_IN,
            data: data.meeting,
            dispatch,
          });
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };
/**
 * ============================= updateMeeting =========================
 * @param {*} info 
 * @param {*} socket 
 * @returns 
 */
export const updateMeeting =
  (info, socket) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const URL = `/api/meeting/${info.id}`;
        const formData = new FormData();
        formData.append("name", info.name);
        if (info.roomId) {
          formData.append("roomId", info.roomId);
        }
        if (info.status) {
          formData.append("status", info.status);
        }
        if (info.content) {
          formData.append("comment", info.content);
        }
        if (info.files) {
          for (let i = 0; i < info.files.length; i++) {
            formData.append("attachment", info.files[i]);
          }
        }
        formData.append("venue", info.venue);
        formData.append("end", info.end);
        formData.append("start", info.start);
        formData.append("agenda", info.agenda);
        formData.append("duration", info.duration);
        formData.append("reminder", info.reminder);
        formData.append(`participantsList`, info.files);
        formData.append("participants", JSON.stringify(info.participants));
        const response = await axios.put(URL, formData, header);
        if (response.data) {
          dispatchHandler({
            type: UPDATE_MEETING,
            data: response.data.message,
            dispatch,
          });
          successToast(response?.data?.message);
          return response.status;
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };

/**
 * =========================== getAvailableRooms =========================
 * @param {*} time 
 * @returns 
 */
export const getAvailableRooms =
  (start, end) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });

        const URL = `/api/room/available?start=${start}&end=${end}`;
        const { data } = await axios.get(URL, header);

        if (data) {
          dispatchHandler({
            type: AVAILABLE_ROOM,
            data: data.rooms,
            dispatch,
          });
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };

/**
 * ========================== getRooms ============================
 * @param {*} time 
 * @returns 
 */
export const getRooms =
  (time) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const URL = `/api/room/`;
        const { data } = await axios.get(URL, header);
        if (data) {
          dispatchHandler({
            type: AVAILABLE_ROOM,
            data: data.room,
            dispatch,
          });
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };
/**
 * ========================== downloadDocument ======================
 * @param {*} content 
 * @returns 
 */
export const downloadDocument =
  (content) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const axios_URL = "/api/pdf/download/";
        const { data } = await axios.post(
          axios_URL,
          { content },
          {
            responseType: "blob",
          }
        );
        if (data) {
          const file = new Blob([data], {
            type: "application/pdf;",
          });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };
/**
 * ============================== generalDownload =========================
 * @param {*} id 
 * @param {*} mimeType
 * @param {*} fileName 
 * @param {*} type
 * @returns
 */
export const generalDownload =
  (id, mimeType, fileName, type = null, actualName = null) =>
    async (dispatch) => {
      
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const axios_URL = `${process.env.REACT_APP_BACKEND_URL}/api/download/document/${id}?type=${type}&key=${fileName}`;
        const { data, headers } = await axios.get(
          axios_URL,
          {
            ...header,
            responseType: "blob",
          }
        );
        if (data) {
          const file = new Blob([data], {
            type: mimeType,
          });
          let filename = headers['content-disposition']?.split('filename=')?.pop();
          saveAs(file, actualName ?? filename);
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };
/**
 * ============================== blobToBase64 ===========================
 * @param {*} blob 
 * @returns 
 */
function blobToBase64(blob) {
  return new Promise((resolve, _) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}
/**
 * =========================== downloadBase64 =======================
 * @param {*} id 
 * @param {*} name 
 * @param {*} type 
 * @param {*} fileType 
 * @returns 
 */
export const downloadBase64 =
  (id, name, type, fileType) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const axios_URL = `${process.env.REACT_APP_BACKEND_URL}/api/download/document/${id}?type=${type}&key=${name}`;
        const { data } = await axios.get(
          axios_URL,
          {
            ...header,
            responseType: "blob",
          }
        );
        if (data) {
          const file = new Blob([data], {
            type: fileType,
          });
          return await blobToBase64(file);
        }
      } catch (error) {
        return null;
      }
    };
/**
 * ========================= downloadDocumentById ========================= 
 * @param {*} id 
 * @returns 
 */
export const downloadDocumentById =
  (id) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const url = `/api/pdf/download/${id}`;
        const { data } = await axios.get(url, {
          ...header,
          responseType: "blob",
        });
        if (data) {
          const file = new Blob([data], {
            type: "application/pdf;",
          });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };
/**
 * ========================== exportParticipantsFormat =====================
 * @returns 
 */
export const exportParticipantsFormat = () => async (dispatch) => {
  try {
    dispatchHandler({ type: ERRORS, data: null, dispatch });
    const axios_URL = "/excel/";
    const { data } = await axios.get(axios_URL, {
      ...header,
      responseType: "blob",
    });
    if (data) {
      const file = new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;",
      });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Server Error");
    dispatchHandler({
      type: ERRORS,
      data: error?.response?.data?.message ?? "Server Error",
      dispatch,
    });
  }
};

/**
 * ============================== getMeeting ==========================
 * @param {*} id 
 * @returns 
 */
export const getMeeting =
  (id) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const URL = `/api/meeting/${id}`;
        const { data } = await axios.get(URL, header);
        if (data) {
          dispatchHandler({
            type: GET_MEETING,
            data: data.meeting,
            dispatch,
          });
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };

/**
* ============================== getAllResources ==========================
* @param {*} id 
* @returns 
*/
export const getAllResources =
  (id) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: RESOURCER_LIST_ALL_ERROR, data: null, dispatch });
        const URL = `/api/request/list/resources`;
        const { data } = await axios.get(URL, header);
        if (data) {
          dispatchHandler({
            type: RESOURCER_LIST_ALL,
            data: data,
            dispatch,
          });
        }
      } catch (error) {
        dispatchHandler({
          type: RESOURCER_LIST_ALL_ERROR,
          data: error?.response,
          dispatch,
        });
      }
    };
/**
* ============================== getAllMeetingList ==========================
* @param {*} id 
* @returns 
*/
export const getAllMeetingList =
  (query) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: MEETING_LIST_ALL_ERROR, data: null, dispatch });
        const URL = `/api/meeting/list?${query}`;
        const { data } = await axios.get(URL, header);
        if (data) {
          dispatchHandler({
            type: MEETING_LIST_ALL,
            data: data,
            dispatch,
          });
        }
      } catch (error) {
        dispatchHandler({
          type: MEETING_LIST_ALL_ERROR,
          data: error?.response,
          dispatch,
        });
      }
    };


// =========================================================================================================================

/**
* ============================ getMinutesTemplate ==================
* @returns 
*/
export const getMinutesTemplate = () => async (dispatch) => {
  try {
    dispatchHandler({ type: ERRORS, data: null, dispatch });
    const URL = `/api/minutes/template/`;
    const { data } = await axios.get(URL, header);
    if (data) {
      dispatchHandler({
        type: MINUTES_TEMPLATE,
        data: data.template,
        dispatch,
      });
    }
  } catch (error) {
    // errorToast(error?.response?.data?.message ?? "Server Error");
    dispatchHandler({
      type: ERRORS,
      data: error?.response?.data?.message ?? "Server Error",
      dispatch,
    });
  }
};
/**
 * ========================= createMinutes ========================
 * @param {*} info 
 * @returns 
 */
export const createMinutes =
  (info) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const formData = new FormData();
        formData.append("meetingId", info.meetingId || info.password?.meetingId || "");
        formData.append("password", info.password);
        formData.append("classification", info.classification);
        if (info.listOfAction) {
          formData.append("actionsTaken", JSON.stringify(info.listOfAction));

        }
        if (info.files.length === 0) {
          formData.append("content", info.content);
        }
        for (let i = 0; i < info.files.length; i++) {
          formData.append(`attachment`, info.files[i]);
        }
        const URL = `/api/minutes/`;
        const response = await axios.post(URL, formData, header);
        if (response.data) {
          dispatchHandler({
            type: CREATE_MINUTES,
            data: response.data.message,
            dispatch,
          });
          successToast(response?.data?.message);
        }
        if (response.status === 200) {
          window.location.replace("/admin/meeting");
        }
        return response.data;
      } catch (error) {
        errorToast(error?.data?.message ?? "Server Error");
        return null;
      }
    };
/**
 * ========================= shareMinutes ===========================
 * @param {*} info 
 * @returns 
 */
export const shareMinutes =
  (info) =>
    async (dispatch) => {
      try {
        dispatchHandler({ type: ERRORS, data: null, dispatch });
        const URL = `/api/minutes/share/`;
        const response = await axios.post(URL, info, header);
        if (response.data) {
          dispatchHandler({
            type: CREATE_MEETING,
            data: response.data.message,
            dispatch,
          });
          successToast(response?.data?.message);
        }
        if (response.status === 200) {
          window.location.replace("/admin/meeting");
        }
      } catch (error) {
        errorToast(error?.response?.data?.message ?? "Server Error");
      }
    };

/**
* ============================ get minutesDetails ==================
* @returns 
*/
export const getMinutesDetails = (minutesId) => async (dispatch) => {
  try {
    dispatchHandler({ type: ERRORS, data: null, dispatch });
    const URL = `/api/minutes/${minutesId}`;
    const { data } = await axios.get(URL, header);
    if (data) {
      dispatchHandler({
        type: MINUTES_DETAILS,
        data: data.minutes,
        dispatch,
      });
    }
  } catch (error) {
    errorToast(error?.response?.data?.message ?? "Server Error");
    dispatchHandler({
      type: ERRORS,
      data: error?.response?.data?.message ?? "Server Error",
      dispatch,
    });
  }
};